import React, { Children, cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'

/**
 * The DataLayoutChild's component.
 */
const DataLayoutChild = props => {
  const { children, view } = props
  const enhancedChildren = useMemo(() => Children.map(children, child => cloneElement(child, { view })), [children])

  return <>{enhancedChildren}</>
}

DataLayoutChild.defaultProps = {
  name: 'DataLayoutChild'
}

DataLayoutChild.propTypes = {
  children: PropTypes.node.isRequired,
  view: PropTypes.number
}

export default DataLayoutChild
